/**
 * Frontend URLs and keys.
 *
 * These values are NOT edited here. They come from webadmin/.env, the single
 * config file shared with the PHP backend. Before every `npm start` and
 * `npm run build`, UI/scripts/sync-env.js copies the PUBLIC_* keys from that
 * file into UI/.env.local, which is what process.env reads below.
 *
 * To change an API URL or Stripe key: edit webadmin/.env and rebuild.
 *
 * Note that everything here is compiled into the JavaScript bundle and is
 * readable by any visitor. Only publishable values belong in this file - the
 * Stripe secret key, mail credentials and database password live server-side
 * and are never exposed to the browser.
 */

const isDev = process.env.NODE_ENV === "development";

// In development, relative paths route through the dev-server proxy defined in
// src/setupProxy.js, which makes API calls same-origin and sidesteps CORS.
// In production the absolute URLs from webadmin/.env are used.
const API_URL = process.env.REACT_APP_PUBLIC_API_URL || "";
const PAY_URL = process.env.REACT_APP_PUBLIC_PAY_URL || "";

const BASE_URLS = {
  main: isDev ? "/webadmin/api/" : API_URL,
  webUrl: "/",
  payUrl: isDev ? "/" : PAY_URL,
  stripeKey: process.env.REACT_APP_PUBLIC_STRIPE_KEY || "",
};

// Fail loudly in development rather than silently making requests to the wrong
// place - a blank API URL otherwise shows up as confusing 404s much later.
if (isDev) {
  if (!API_URL) {
    console.error(
      "baseUrl: PUBLIC_API_URL is not set in webadmin/.env - production builds will have no API URL."
    );
  }
  if (!BASE_URLS.stripeKey) {
    console.error(
      "baseUrl: PUBLIC_STRIPE_KEY is not set in webadmin/.env - checkout will not load."
    );
  }
}

export default BASE_URLS;
